/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiRateLimitEndpoint } from './InternalApiRateLimitEndpoint';
import {
    InternalApiRateLimitEndpointFromJSON,
    InternalApiRateLimitEndpointFromJSONTyped,
    InternalApiRateLimitEndpointToJSON,
    InternalApiRateLimitEndpointToJSONTyped,
} from './InternalApiRateLimitEndpoint';

/**
 * 
 * @export
 * @interface InternalApiRateLimitBucket
 */
export interface InternalApiRateLimitBucket {
    /**
     * 
     * @type {string}
     * @memberof InternalApiRateLimitBucket
     */
    bucketName: string;
    /**
     * 
     * @type {Array<InternalApiRateLimitEndpoint>}
     * @memberof InternalApiRateLimitBucket
     */
    endpoints: Array<InternalApiRateLimitEndpoint>;
    /**
     * 
     * @type {number}
     * @memberof InternalApiRateLimitBucket
     */
    limitPerSecond: number;
}

/**
 * Check if a given object implements the InternalApiRateLimitBucket interface.
 */
export function instanceOfInternalApiRateLimitBucket(value: object): value is InternalApiRateLimitBucket {
    if (!('bucketName' in value) || value['bucketName'] === undefined) return false;
    if (!('endpoints' in value) || value['endpoints'] === undefined) return false;
    if (!('limitPerSecond' in value) || value['limitPerSecond'] === undefined) return false;
    return true;
}

export function InternalApiRateLimitBucketFromJSON(json: any): InternalApiRateLimitBucket {
    return InternalApiRateLimitBucketFromJSONTyped(json, false);
}

export function InternalApiRateLimitBucketFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiRateLimitBucket {
    if (json == null) {
        return json;
    }
    return {
        
        'bucketName': json['bucketName'],
        'endpoints': ((json['endpoints'] as Array<any>).map(InternalApiRateLimitEndpointFromJSON)),
        'limitPerSecond': json['limitPerSecond'],
    };
}

export function InternalApiRateLimitBucketToJSON(json: any): InternalApiRateLimitBucket {
    return InternalApiRateLimitBucketToJSONTyped(json, false);
}

export function InternalApiRateLimitBucketToJSONTyped(value?: InternalApiRateLimitBucket | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'bucketName': value['bucketName'],
        'endpoints': ((value['endpoints'] as Array<any>).map(InternalApiRateLimitEndpointToJSON)),
        'limitPerSecond': value['limitPerSecond'],
    };
}

